import React from 'react'
import IntroContainer from '../components/Intro/IntroContainer'

const Intro = () => {
    return (
        <>
            <IntroContainer />
        </>
    )
}

export default Intro
